// extracted by mini-css-extract-plugin
export default {"largeCtaContainer":"ResearchDetail_largeCtaContainer__6YcGe","largeCta":"ResearchDetail_largeCta__SeVzc"};